var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex my-2"},[_c('a',{staticClass:"button is-info",class:{ 'is-outlined': !_vm.isPlusClick },on:{"click":_vm.ownerPlus}},[_vm._v("+")]),_c('a',{staticClass:"button is-info",class:{ 'is-outlined': !_vm.isMinusClick },on:{"click":_vm.ownerMinus}},[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }